import { NoticeContainer, NoticeItem, NoticeList } from './styles'

export function DetailNotice() {
  const notices = [
    '신청일 기준 익일 오전 11시까지 수정이 가능해요',
    '주소 변경을 원하실 경우 취소 후 다시 신청해주세요',
  ]

  return (
    <NoticeContainer>
      <NoticeList>
        {notices.map((text) => (
          <NoticeItem key={text}>{text}</NoticeItem>
        ))}
      </NoticeList>
    </NoticeContainer>
  )
}
